import type { PartialMessages } from "../messages";

export const fr: PartialMessages = {
  "status.syncing": "Synchronisé",
  "status.connecting": "Connexion",
  "status.full": "Complet",
  "status.closed": "Déconnecté",
  "toast.connecting": "Connexion…",
  "toast.reconnecting": "Déconnecté. Nouvelle tentative…",
  "toast.retrying": "Nouvel essai dans un instant.",
  "toast.busy": "Forte affluence en ce moment",
  "notice.mapChanged": "{name} a changé de carte",

  "hint.place": "Cliquez pour poser, glissez pour orienter (Échap pour annuler)",

  "kind.objective": "Objectif",
  "kind.rally": "Ralliement",
  "kind.enemy": "Ennemi",
  "kind.loot": "Butin",
  "kind.extract": "Extraction",
  "kind.danger": "Danger",
  "kind.self": "Moi",
  "kind.ping": "Ici !",
  "hint.objective": "Où vous allez",
  "hint.rally": "Point de regroupement",
  "hint.enemy": "Orientez-le vers l'endroit où vous l'avez vu",
  "hint.loot": "Conteneurs rares, cadavres",
  "hint.extract": "L'extraction prévue",
  "hint.danger": "Mines, snipers, terrain découvert",
  "hint.self": "Votre position. La reposer efface l'ancienne",
  "hint.ping": "Marqueur temporaire qui disparaît après 25 secondes",

  "tool.clearMine": "Effacer les miens",
  "tool.clearMineHint": "Retire tous les repères que vous avez posés",

  "sidebar.map": "Carte (pour tout le monde)",
  "sidebar.styleSvg": "Illustrée",
  "sidebar.styleTile": "Satellite",
  "sidebar.floors": "Étage (n'affecte que votre vue)",
  "sidebar.groundFloor": "Rez-de-chaussée",
  "sidebar.floorNote": "Les repères des autres étages sont atténués.",
  "sidebar.members": "{count} présents",
  "sidebar.you": "vous",
  "sidebar.guest": "invité",
  "sidebar.clearAll": "Effacer tous les repères",
  "sidebar.openWindow": "Ouvrir dans une fenêtre (pour moi)",
  "sidebar.invite": "Inviter quelqu'un",
  "sidebar.help": "Mode d'emploi",
  "sidebar.feedback": "Envoyer un retour",
  "sidebar.mapData": "Données cartographiques",
  "sidebar.license": "Licence",
  "sidebar.licenseNote": "usage non commercial uniquement",
  "sidebar.room": "Salon",

  "pin.facing": "Orientation",
  "pin.floor": "Étage",
  "pin.map": "Carte",
  "pin.noFacing": "Sans orientation",
  "pin.facingValue": "{compass} ({degrees}°)",
  "pin.notePlaceholder": "Ajouter une note (ex. fenêtre du 3e étage)",
  "pin.removeMine": "Supprimer ce repère",
  "pin.removeOther": "Supprimer le repère d'un autre",
  "pin.close": "Fermer",
  "compass.n": "N", "compass.ne": "NE", "compass.e": "E", "compass.se": "SE",
  "compass.s": "S", "compass.sw": "SO", "compass.w": "O", "compass.nw": "NO",

  "handoff.title": "Ouvrir dans une fenêtre",
  "handoff.lede":
    "Un lien pour vous. Il ouvre le même salon dans un navigateur, pour que Discord garde le partage d'écran pendant que la carte reste sur un autre écran.",
  "handoff.open": "Ouvrir dans le navigateur de cet ordinateur",
  "handoff.or": "Sur un autre appareil",
  "handoff.codeHint": "Sur cet appareil, allez sur {host}/j/ puis saisissez le code ci-dessus.",
  "handoff.copy": "Copier le lien",
  "handoff.copied": "Copié",
  "handoff.copyFailed": "Sélectionné ci-dessus — appuyez sur Ctrl+C",
  "handoff.expiry": "Ce lien ne sert qu'une fois. Il expire dans {time}.",
  "handoff.warn":
    "Ne le transmettez pas : l'ouvrir le consomme. Pour cela, utilisez « Inviter quelqu'un ».",
  "handoff.creating": "Création du lien…",
  "handoff.failed": "Impossible de créer le lien",

  "invite.title": "Inviter quelqu'un",
  "invite.lede":
    "Faites venir quelqu'un qui n'est pas dans le salon vocal. Il saisit un nom et peut poser des repères.",
  "invite.copy": "Copier le lien",
  "invite.warn": "Toute personne ayant ce lien peut rejoindre. Ne le publiez pas.",
  "invite.budget": "Encore {left} personnes, expire dans {time} (utilisé {used}/{max}).",
  "invite.revoke": "Révoquer ce lien maintenant",
  "invite.revoked": "Lien révoqué.",
  "invite.creating": "Création du lien…",
  "invite.failed": "Impossible de créer le lien",
  "invite.revokeFailed": "Révocation impossible",

  "join.title": "Rejoindre la carte",
  "join.lede":
    "Vous avez été invité sur une carte de raid. Choisissez un nom à afficher ; il apparaîtra sur vos repères.",
  "join.name": "Nom",
  "join.go": "Rejoindre",
  "join.joining": "Connexion…",
  "join.failed": "Impossible de rejoindre",

  "feedback.title": "Écrire à l'auteur",
  "feedback.request": "Suggestion",
  "feedback.bug": "Bug",
  "feedback.other": "Autre",
  "feedback.requestHint": "Ce serait bien si…",
  "feedback.bugHint": "Quelque chose ne va pas",
  "feedback.otherHint": "N'importe quoi d'autre",
  "feedback.placeholder":
    "ex. j'aimerais tracer des lignes, pas seulement des flèches / les étages ne changent pas sur Streets",
  "feedback.note":
    "Votre nom Discord et votre identifiant sont joints, pour pouvoir vous répondre.",
  "feedback.send": "Envoyer",
  "feedback.sending": "Envoi…",
  "feedback.sent": "Envoyé. Merci !",
  "feedback.failed": "Échec de l'envoi",

  "time.minutes": "{n} min",
  "time.hoursMinutes": "{h} h {m} min",

  "error.roomFull": "Ce salon est complet",
  "error.tooManyWindows": "Trop de fenêtres ouvertes sur ce salon. Fermez-en une.",
  "error.serverFull": "Le serveur est saturé",
  "error.session": "Votre session n'est plus valide. Veuillez rouvrir.",
  "error.handoffSpent":
    "Ce lien ne fonctionne pas. C'est un lien à usage unique réservé à celui qui l'a créé. Pour faire venir quelqu'un, créez un lien d'invitation depuis la carte.",
  "error.inviteSpent": "Ce lien d'invitation n'est plus utilisable. Demandez-en un nouveau.",
  "error.inviteNotOwner": "Seul l'auteur du lien peut le révoquer",
  "error.noRoom": "Aucun salon indiqué",
  "error.needName": "Veuillez saisir un nom",
  "error.tooShort": "Écrivez un peu plus, s'il vous plaît",
  "error.tooLong": "C'est trop long",
  "error.badKind": "Catégorie invalide",
  "error.rateLimited": "Trop de messages. Patientez une dizaine de minutes.",
  "error.busy": "Forte affluence. Réessayez dans un instant.",
  "error.sendFailed": "Envoi impossible. Réessayez plus tard.",
  "error.feedbackClosed": "Les retours sont fermés pour le moment",
  "error.sessionGone": "La session d'origine est terminée. Rouvrez depuis l'activité.",

  "landing.tagline1": "Partagez une carte de Tarkov",
  "landing.tagline2": "avec tout le monde en vocal sur Discord, et expliquez-la ensemble.",
  "landing.install": "Ajouter à Discord",
  "landing.installNote": "Gratuit. Lancez-le via l'icône fusée d'un salon vocal.",
  "landing.body":
    "Tout le monde voit la même carte. Un clic pose un repère ; en glissant, vous y ajoutez une flèche de direction — vous montrez donc non seulement où, mais aussi vers où.",
  "landing.point1": "Être dans le même vocal suffit. Aucun code à saisir",
  "landing.point2": "Les 13 cartes. Illustrées ou satellite, et les étages",
  "landing.point3": "Les repères restent en place et se consultent plus tard",
  "landing.point4": "Ceux qui ne sont pas en vocal rejoignent par un lien d'invitation",
  "landing.footNote":
    "Le jeu n'est jamais touché. Aucun fichier, aucune mémoire, rien d'affiché par-dessus le jeu. Chaque repère est posé à la main.",
  "landing.footCredit":
    "Un projet amateur, gratuit. Données cartographiques de {tarkovdev} (CC BY-NC-SA 4.0). Escape from Tarkov est un produit de Battlestate Games Limited ; ceci est un projet de fan non officiel, sans lien avec eux.",
  "landing.updates": "Nouveautés",
  "landing.allUpdates": "Toutes les nouveautés",

  "boot.connecting": "Connexion à Discord…",
  "boot.failedTitle": "Démarrage impossible",
};
